import { CentroCosto } from 'core/centrocosto/models/CentroCosto';
import { Tarjeta } from 'core/tarjeta/models/Tarjeta';

export const mapTipoUsuario = (tipoUsuario: TipoUsuario): string => {
  switch (tipoUsuario) {
    case 'CENTRO_COSTO':
      return 'Centro Costo';
    case 'OPERADOR':
      return 'Operador';
    case 'BANCO':
      return 'Banco';
    case 'TARJETA':
      return 'Tarjeta';
  }
};

export type TipoUsuario = 'OPERADOR' | 'BANCO' | 'CENTRO_COSTO' | 'TARJETA';

export class Usuario {
  id: number;
  username: string;
  mail: string;
  detalle: string;
  tipoUsuario: TipoUsuario;
  cuentaRaiz: boolean;
  skipsRemaining: number;
  mailStatus: string;
  lastLogin: string;
  funcionalidades: string[] = [];
  impersonation?: boolean;
  actorUsername?: string;
  recursoControlado: Partial<Tarjeta> | Partial<CentroCosto>;
}
